module.exports = __webpack_public_path__ + "static/media/perfil-ranking.660271ea.svg";